import {getComponentInfo, PAGE_TYPE} from "@/common/consts/service.js";
import {schema} from "@/common/utils/webview.js";

export default {
    data() {
        return {
            headerComponent: null,
            componentInfo: getComponentInfo(this.serviceId, PAGE_TYPE.RESPONSE)
        }
    },

    computed: {
        isWebView() {
            return this.$route.query.hasOwnProperty('isMasking');
        },
    },

    methods: {
        showImage({index}) {
            if (this.isWebView) {
                schema('webview', `article/preview/multimedia?index=${index}`);
                return;
            }

            if (this.isPreview) {
                return;
            }

            this.$router.push({
                name: `${this.type}ResponseImage`,
                query: {
                    ...this.$route.query,
                    order: index
                }
            });
        },

        showFile({index}) {
            if (this.isWebView) {
                schema('webview', `article/preview/attachment?index=${index}`);
                return;
            }

            if (this.isPreview) {
                return;
            }

            this.$router.push({
                name: `${this.type}ResponseFile`,
                query: {
                    ...this.$route.query,
                    order: index
                }
            });
        },
    },

    created() {
        this.componentInfo.headerComponent.then(c => this.headerComponent = c.default);
        this.$eventBus.$on('clickPreviewImage', this.showImage);
        this.$eventBus.$on('clickPreviewFile', this.showFile);
    },

    beforeDestroy() {
        this.$eventBus.$off('clickPreviewImage', this.showImage);
        this.$eventBus.$off('clickPreviewFile', this.showFile);
    }
}
